const styles = theme => ({
  navBar: {
    width: '100%',
    backgroundColor: '#fff',
  },
  navBarInner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: 72,
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 0,
  },
  trialBanner: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    padding: '8px 0 24px',
    marginBottom: 8,
  },
  trialSubtitle: {
    color: 'var(--Color---Dark, #637381)',
    textAlign: 'center',
    fontFamily: 'Inter',
    fontSize: '32px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '64px',
    letterSpacing: '-0.64px',
  },
  trialTitle: {
    color: '#0B1D2E',
    textAlign: 'center',
    fontFamily: 'Inter',
    fontSize: '40px',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: '150%',
    letterSpacing: '-0.8px',
    maxWidth: 760,
    '@media (max-width: 600px)': {
      fontSize: '28px',
      lineHeight: '36px',
    },
  },
  contactSupport: {
    fontSize: '14px',
    color: '#637381',
    fontFamily: 'Inter',
    whiteSpace: 'nowrap',
    marginLeft: theme.spacing(2),
  },
  contactLink: {
    color: '#015FFB',
    fontWeight: 600,
    textDecoration: 'none',
    '&:visited': {
      color: '#015FFB',
    },
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  // Kept in sync with the same toggles on /pricing (src/pages/pricing/style.js).
  audienceToggle: {
    display: 'inline-flex',
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 6,
    marginTop: 8,
    boxShadow: '0 2px 12px rgba(0, 0, 0, 0.06)',
    border: '1px solid rgba(0, 0, 0, 0.05)',
  },
  audienceOption: {
    padding: '12px 40px',
    borderRadius: 8,
    fontSize: 18,
    fontFamily: 'Inter',
    fontWeight: 700,
    color: '#002E47',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    userSelect: 'none',
    '&:hover': {
      color: '#015FFB',
    },
  },
  audienceActive: {
    backgroundColor: '#015FFB',
    color: '#fff',
    '&:hover': {
      color: '#fff',
    },
  },
  billingToggle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    marginTop: 32,
    marginBottom: 40,
  },
  billingLabel: {
    fontSize: 14,
    fontFamily: 'Inter',
    fontWeight: 500,
    color: '#637381',
    cursor: 'pointer',
    userSelect: 'none',
  },
  billingLabelActive: {
    fontWeight: 700,
    color: '#002E47',
  },
  billingSwitch: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    flexShrink: 0,
    height: 24,
    width: 44,
    padding: 0,
    border: 'none',
    borderRadius: 9999,
    backgroundColor: 'rgba(0, 0, 0, 0.15)',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
  },
  billingSwitchOn: {
    backgroundColor: '#015FFB',
  },
  billingKnob: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 16,
    width: 16,
    borderRadius: '50%',
    backgroundColor: '#fff',
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)',
    transform: 'translateX(4px)',
    transition: 'transform 0.2s ease',
  },
  billingKnobOn: {
    transform: 'translateX(24px)',
  },
  billingBadge: {
    borderRadius: 9999,
    padding: '2px 10px',
    fontSize: 12,
    fontFamily: 'Inter',
    fontWeight: 700,
    color: '#fff',
    backgroundColor: '#637381',
    transition: 'background-color 0.2s ease',
  },
  billingBadgeOn: {
    backgroundColor: '#015FFB',
  },
  currentPlanBadge: {
    display: 'flex',
    padding: '12px 24px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
    borderRadius: 32,
    fontFamily: 'Inter',
    fontSize: 16,
    fontWeight: 500,
    lineHeight: 'normal',
    marginBottom: 16,
  },
  rootHeader: {
    maxWidth: 1280,
  },
  typographyHeader: {
    color: 'var(--mcg-dark, #002E47)',
    textAlign: 'center',
    fontFamily: 'Inter',
    fontSize: '32px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '150%',
    marginTop: '40px',
    width: '100%',
    maxWidth: 1280,
  },
})

export default styles
